import { QueryClient, MutationCache } from '@tanstack/react-query';
import { toast } from '@mlm/ui';
import { apiErrorMessage } from './api';

/**
 * Typed mutation `meta`. A mutation opts into a success toast by declaring
 * `meta: { successMessage: 'Saved.' }`; `errorMessage` overrides the default
 * server-derived error toast for that mutation.
 */
declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      successMessage?: string;
      errorMessage?: string;
    };
  }
}

/**
 * Shared QueryClient. The MutationCache gives every save/mutation feedback for
 * free: any failure toasts the server's error message (no silent failures), and
 * a mutation shows a success toast when it sets `meta.successMessage`.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, gcTime: 5 * 60_000, retry: 1 } },
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      toast.error(
        mutation.meta?.errorMessage ??
          apiErrorMessage(error, 'Something went wrong. Please try again.'),
      );
    },
    onSuccess: (_data, _vars, _ctx, mutation) => {
      if (mutation.meta?.successMessage) toast.success(mutation.meta.successMessage);
    },
  }),
});
